import { Modal, Image, Button } from "antd"
import styles from "@/styles/checkout.module.scss"
export default function LearnMore({ showLearnMore, setShowLearnMore, learnMoreItem }: { showLearnMore: boolean, setShowLearnMore: Function, learnMoreItem: any }) {

  return (
    <Modal open={showLearnMore} onCancel={() => { setShowLearnMore(false) }} footer={null}>
      <div className={styles['learnmore-content']}>
        <p className={styles['learnmore-content-line']} dangerouslySetInnerHTML={{ __html: learnMoreItem.description }}></p>
      </div>
    </Modal>
  )
}